const Wrapper = require('./Wrapper');
const CityInputWrapper = require('./CityInputWrapper');

class GoodModel {
    constructor() {
        this.fromCity = null;
        this.toCity = null;
        this.goodType = 0;
        this.quantity = 1;
        this.price = 0;
        this.currency = 1;
    }
}

class GoodWrapper extends Wrapper {
    constructor(id, model = new GoodModel()) {
        super(true);
        this.model = model;
        this.id = id;

        let prices = document.getElementById('Prices').innerHTML;
        prices = JSON.parse(prices);
        this.prices = prices;

        let translationsJSON = document.getElementById('Translations').innerHTML;
        this.translations = JSON.parse(translationsJSON)
    }

    template(number = 1) {
        let goodTypes = document.getElementById('goodTypes').innerHTML;
        let translations = this.translations;
        let label = document.getElementById('priceLabel').innerHTML;

        return `
            <fieldset class="sub-fieldset sub-fieldset-luggage-price one-way" id="${this.id}">
                <!-- one-way-->
                <i class="round-number">${number}</i>
                <ul class="form-floor">
                    ${goodTypes}
                </ul>
                <hr style="display: none">
                <ul class="form-floor">
                    <li><i class="fa fa-map-signs" title="${translations['can-take-input-fromcity']}"></i>
                        <input type="text" id="${this.id + '-from-city'}" autocomplete="offo" placeholder="${translations['can-take-input-fromcity']} *" required>
                    </li>
                    <li><i class="fa fa-map-signs" title="${translations['can-take-input-tocity']}"></i>
                        <input type="text" id="${this.id + '-to-city'}" autocomplete="offo" placeholder="${translations['can-take-input-tocity']} *" required>
                    </li>
                </ul>
                <button type="button" class="round-button round-trash" data-delete-good="${this.id}" title="Delete"><i class="fa fa-trash-o"></i></button>
                <div class="price-cont">
                    <div id="price">
                        <label>${translations[`price-input-label-type-${this.model.goodType}`]}</label> 
                        <input type="number" class="price-input" placeholder="${translations['by-agreement-input-label']}"> 
                    </div>
                    <div class="currency">
                        <span class="currency-icon" style="display: none;"></span>
                        <select name="currency" class="travel currency-list">
                            <option selected="selected" value="1" class="icon-dram"></option>
                            <option value="2" class="icon-ruble"></option>
                            <option value="3" class="icon-dollar"></option>
                            <option value="4" class="icon-euro"></option>
                        </select>
                    </div>
                </div>
            </fieldset>
            `;
    }

    get goodType() {
        return Number(window.$(`#${this.id} .travel`).val());
    }

    set goodType(value) {
        window.$(`#${this.id} .travel`).val(value).selectric('refresh');
    }

    removeButtonVisibility(show = true) {
        let $elem = window.$(`#${this.id} .round-trash`);
        if (show) $elem.show();
        else $elem.hide();
    }

    cityInputsVisibility(show = true) {
        this._cityInputsVisibility = show;

        if (show) {
            window.$(this.fromCity.element).parent().show();
            window.$(this.toCity.element).parent().show();
            this.fromCity.element.setAttribute('required', '1');
            this.toCity.element.setAttribute('required', '1');
            document.getElementById(`${this.id}`).classList.remove('one-way');
            $(`#${this.id} hr`).show();
        } else {
            window.$(this.fromCity.element).parent().hide();
            window.$(this.toCity.element).parent().hide();
            this.fromCity.element.removeAttribute('required');
            this.toCity.element.removeAttribute('required');
            document.getElementById(`${this.id}`).classList.add('one-way');
            $(`#${this.id} hr`).hide();
        }
    }

    initWrappers() {
        this.fromCity = new CityInputWrapper(this.id + '-from-city');
        this.fromCity.updateModel(this.model.fromCity);

        this.toCity = new CityInputWrapper(this.id + '-to-city');
        this.toCity.updateModel(this.model.toCity);

        this.$quantityInputElement = window.$(`#${this.id} .quantity`);
        this.$priceInputElement = window.$(`#${this.id} .price-input`);
        this.$goodTypeInputElement = window.$(`#${this.id} .travel.luggage`);
        this.$currencyInputElement = window.$(`#${this.id} .price-cont select`);

        this.$priceInputElement.val(this.model.price || '');
        this.$quantityInputElement.val(this.model.quantity);
        this.$goodTypeInputElement.val(this.model.goodType || '')
        this.$currencyInputElement.val(this.model.currency || '')

        const that = this;
        setTimeout(() => that.updateSelectricIcons(), 100)

        this.initEvents();
    }

    getSelectedGoodType() {
        const selectElement = this.$goodTypeInputElement[0]

        const selectedOption = selectElement.querySelectorAll(`option`)[selectElement.selectedIndex]

        if (selectedOption)
            return selectedOption.getAttribute('value')

        return null;
    }

    isValid() {
        let criteria1 = !this._cityInputsVisibility || this.fromCity.isValid() && this.toCity.isValid();

        let criteria2 = this.getSelectedGoodType() && Number(this.getSelectedGoodType()) !== 0;

        let vals = ['1', '2'];
        let criteria3 = Boolean(Number(this.$quantityInputElement.val())) || vals.includes(this.$goodTypeInputElement.val());

        return criteria1 && criteria2 && criteria3;
    }

    validate() {
        this.fromCity.validate();
        this.toCity.validate();

        let vals = ['1', '2'];
        if (Boolean(Number(this.$quantityInputElement.val())) || vals.includes(this.$goodTypeInputElement.val())) {
            this.$quantityInputElement.removeClass('invalid');
        } else {
            this.$quantityInputElement.addClass('invalid');
        }

        if (this.$goodTypeInputElement.val() !== "0") {
            this.$goodTypeInputElement.parent().parent().removeClass('invalid');
        } else {
            this.$goodTypeInputElement.parent().parent().addClass('invalid');
        }
    }

    syncUIWithModel() {
        this.fromCity.updateUI();
        this.toCity.updateUI();
        this.goodType = this.model.goodType;
        this.$quantityInputElement.val(this.model.quantity);
    }

    set quantity(value) {
        this.updateModel({ quantity: value })
    }

    set price(value) {
        this.updateModel({ price: value })
    }

    updatePrice() {
        let type = this.model.goodType;
        let quantity = this.model.quantity;
        let price = Number(this.prices[type - 1] * quantity) || 0;
        $(`#${this.id} .price span`).html(price);
    }

    updateSelectricIcons() {
        const that = this;
        // Good type
        const partentElement = document.querySelector(`#${that.id} ul:first-child li:first-child`);
        const selectElement = that.$goodTypeInputElement[0]

        const selectedOption = selectElement.querySelectorAll(`option`)[selectElement.selectedIndex]

        if (!selectedOption) return;

        const iconKey = selectedOption.getAttribute('class').replace('icon-', '')

        $(document.querySelector(`#${that.id} i.fa`)).hide()

        $(document.querySelector(`#${that.id} .luggage-icon`)).show()

        document.querySelector(`#${that.id} .luggage-icon`).innerHTML = `<svg class="select-icon"><use xlink:href="#${iconKey}"></use></svg>`
    }

    initEvents() {
        const that = this;
        this.fromCity.addListener(() => {
            this.updateModel({ fromCity: this.fromCity.model });
        });

        this.toCity.addListener(() => {
            this.updateModel({ toCity: this.toCity.model });
        });

        this.$goodTypeInputElement.on('change', () => {
            this.updateModel({ goodType: this.goodType });

            // update price label
            document.querySelector(`#${that.id} #price label`).innerHTML = that.translations[`price-input-label-type-${that.model.goodType}`]

            this.updateSelectricIcons();
        });

        let getQuantityInputValue = () => Number(this.$quantityInputElement.val()) || 0;
        let getPriceInputValue = () => Number(this.$priceInputElement.val()) || 0;

        this.$quantityInputElement.on('input', () => {
            this.quantity = getQuantityInputValue();
        });

        this.$priceInputElement.on('input', () => {
            this.price = getPriceInputValue();
        });


        let quantityHandler = () => {


            let titles = document.querySelector('.quantityContainer').getAttribute('data-titles');
            titles = titles.split(',');

            let placeholder = '';

            let types1 = [1, 2];
            let types2 = [4, 5];
            if (types1.includes(this.model.goodType)) placeholder = titles[0] + ' *';
            if (types2.includes(this.model.goodType)) placeholder = titles[1] + ' *';
            if (this.model.goodType === 3) placeholder = titles[2] + ' *';

            this.model.quantity = getQuantityInputValue();
            this.$quantityInputElement.attr('placeholder', placeholder);

            this.updatePrice();
        };

        this.addListener(quantityHandler);
        quantityHandler();

        const updateSelectricIcon = () => {
            const selectElement = that.$currencyInputElement.get(0)

            const selectedOption = selectElement.querySelectorAll(`option`)[selectElement.selectedIndex]

            const iconKey = selectedOption.getAttribute('class').replace('icon-', '')

            $(document.querySelector(`#${that.id} .currency-icon`)).show()

            document.querySelector(`#${that.id} .currency-icon`).innerHTML = `<svg class="select-icon"><use xlink:href="#${iconKey}"></use></svg>`
        }

        this.$currencyInputElement.on('change', () => {
            this.updateModel({ currency: Number(that.$currencyInputElement.val()) });

            updateSelectricIcon()
        })

        updateSelectricIcon()
    }
}

module.exports = GoodWrapper;